import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId28: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/06/25/JP_fuji_ex.jpg",
  },
  package: {
    showAllSubLOB: false,
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://cars.cartrawler.com/expedia/{locale}_JP/book#/vehicles",
    },
    carType: "CARTRAWLER",
    clientID: 791862,
    residenceID: "JP",
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
  },
  hotel: {
    useDialogTextWithoutCar: true,
  },
};
